import React from "react";
import { Link, useRouteError } from "react-router-dom";

const ErrorPage: React.FC = () => {
  const error: any = useRouteError();
  console.error(error);
  return (
    <div>
      <h1>Error 404</h1>
      <p>The requested page could not be found.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default ErrorPage;
